<script setup>
import Title from "@/components/atoms/titre";
import LazyImage from "@/components/atoms/lazy-image";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import ajouterCarteCarrefourPush from "@/assets/images/espace-fid/illus-economie-carrefour.svg";

const emit = defineEmits(["addCarte"]);
</script>
<template>
  <div>
    <div class="u-flex u-flex-column@md u-flex-align-center u-gap-lg25 u-gap-sm@md u-mb-md">
      <div>
        <LazyImage
          :src="ajouterCarteCarrefourPush"
          alt=""
          width="274"
          class="u-max-width-20@md"
        />
      </div>
      <div>
        <Title
          tag="h2"
          size="xs"
          class="u-mb-xxs"
        >
          Gagnez à toutes les courses
        </Title>
        <p>
          Économisez en moyenne <strong>149 €*</strong> et plus par an grâce à nos promos, avec la carte de Fidélité Carrefour&nbsp;!
        </p>
        <div class="u-flex u-flex-wrap u-gap-sm u-flex-justify-center@md u-mt-md">
          <Button
            variant="primary"
            radius="full"
            size="md"
            class="u-max-width-30 u-full-width"
            @click="emit('addCarte')"
          >Ajouter ma Carte</Button>
          <ButtonIcon
            variant="primary"
            radius="full"
            size="md"
            outline
            icon-name="external"
            icon-position="right"
            icon-color="primary"
            class="u-max-width-30 u-full-width"
            target="_blank"
            to="https://www.carrefour.fr/mon-compte/inscription"
          >Créer ma Carte</ButtonIcon>
        </div>
      </div>
    </div>
    <p class="u-font-12">*Moyenne des économies réalisées sur l'année 2021 dans les magasins Carrefour Hyper et Supermarché, par les clients inscrits au Programme de Fidélité Carrefour</p>
  </div>
</template>